import React from "react";
import WorkspaceSidebar from "../../components/chat-companion/WorkspaceSidebar/WorkspaceSidebar";
import { useCompanionThreads } from "../../contexts/CompanionThreadsContext";
import { GENERAL_WORKSPACE_ID } from "../../hooks/useWorkspaceLists";

const WorkspaceSidebarContainer = () => {
  const {
    generalWorkspaces,
    courseWorkspaces,
    todoWorkspaces,
    learningActivitiesWorkspaces,
    settingsWorkspaces,
    activeWorkspaceId,
    activeThreadId,
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    openWorkspaceId,
    toggleWorkspaceDrawer,
    threadsByWorkspaceId,
    isLoadingCourseWorkspaces,
    onWorkspacePress,
    onThreadSelect,
    onThreadDelete,
    onNewThread,
    onThreadRename,
    onThreadLoadMore,
  } = useCompanionThreads();

  return (
    <WorkspaceSidebar
      generalWorkspaces={generalWorkspaces}
      courseWorkspaces={courseWorkspaces}
      todoWorkspaces={todoWorkspaces}
      learningActivitiesWorkspaces={learningActivitiesWorkspaces}
      settingsWorkspaces={settingsWorkspaces}
      activeWorkspaceId={activeWorkspaceId || GENERAL_WORKSPACE_ID}
      onWorkspacePress={onWorkspacePress}
      threadsByWorkspaceId={threadsByWorkspaceId}
      isLoadingCourseWorkspaces={isLoadingCourseWorkspaces}
      onThreadLoadMore={onThreadLoadMore}
      onThreadSelect={onThreadSelect}
      onThreadDelete={onThreadDelete}
      onNewThread={onNewThread}
      onThreadRename={onThreadRename}
      activeThreadId={activeThreadId}
      isSidebarCollapsed={isSidebarCollapsed}
      setIsSidebarCollapsed={setIsSidebarCollapsed}
      openWorkspaceId={openWorkspaceId}
      toggleWorkspaceDrawer={toggleWorkspaceDrawer}
    />
  );
};

export default WorkspaceSidebarContainer;
